var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button",on:{"click":_vm.print}},[_c('a-icon',{staticStyle:{"font-size":"18px"},attrs:{"type":"printer"}}),_c('div',[_vm._v("打印地图")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }